module.exports = __webpack_public_path__ + "img/job2.23f79a02.jpg";